module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAcElEQVQ4T2NgGBSA0ajqPwjDwHkRbTBGZmPDQ8iAy2o2/z8fOw3mg2gQH8WA/3gASOHnoxBNr2YvgRh25BSqAficCXPJq1lL/p8X1fn/auZiuMFEGwBzNkgz2AVAF5FkAEwTCMC8Q5IBuPAgMmBoAwDU5XabzW8RvAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/WF.png
// module id = 1302
// module chunks = 0